import { render, staticRenderFns } from "./HeroReviews.vue?vue&type=template&id=6dd249b2&scoped=true"
import script from "./HeroReviews.vue?vue&type=script&lang=js"
export * from "./HeroReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd249b2",
  null
  
)

export default component.exports